import { apiPost } from "@/lib/http/client";
import type { CreateExportJobFromSelectionRequest, CreateExportJobResponse } from "@/types/api";

export async function createExportJob(body: CreateExportJobFromSelectionRequest) {
  return apiPost<CreateExportJobResponse>("/export-jobs/from-selection", body);
}
